<template>
  <b-container fluid>
    <b-row v-if="searching">
      <b-col>
        <search-influencer @close="init()" />
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="12" class="search-trigger pr-0 pr-md-3">
        <b-icon-search class="cursor" @click="searching = true" />
      </b-col>

      <b-tabs content-class="mt-3" v-model="tabIndex" style="width: 100%">
        <b-tab
          v-for="(tab, key) in tabs"
          :key="key"
          :title="tab.name"
          :active="tab.active"
          :lazy="tab.lazy"
          @click="setTabs(key)"
        >
          <home-feeds :list="tab.filter"></home-feeds>
        </b-tab>
      </b-tabs>
    </b-row>
  </b-container>
</template>

<script>
import HomeFeeds from '@/views/Home/Feeds/List'
import SearchInfluencer from '@/views/components/SearchInfluencer'

export default {
  name: 'FeedsIndex',
  components: {
    HomeFeeds,
    SearchInfluencer,
  },
  data() {
    return {
      tabIndex: 0,
      searching: false,
      showClear: false,
      showSearch: false,
      showSearchButton: true,
    }
  },

  computed: {
    tabs() {
      return [
        { name: 'All', filter: 'all', active: true, lazy: false },
        { name: 'VIP', filter: 'vip', active: false, lazy: true },
      ]
    },
  },

  methods: {
    setTabs(n) {
      this.tabs[n].active = true
      this.tabs[this.tabIndex].active = false
      this.tabs[n].lazy = false
      this.tabs[this.tabIndex].lazy = true
    },
    init() {
      this.searching = false
    },
  },
}
</script>

<style lang="scss"></style>
